<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">商品中心</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="商品名称" prop="name">
            <el-input size="small" style="width: 200px;" v-model="formInline.name" placeholder="商品名称"></el-input>
          </el-form-item>


<!--          <el-form-item label="所属分类" prop="parentId">-->
<!--            <el-select v-model="formInline.parentId" placeholder="请选择"  style="height: 33px;width: 250px;">-->
<!--              <el-option-->
<!--                v-for="item in comList"-->
<!--                :key="item.id"-->
<!--                :label="item.name"-->
<!--                :value="item.id">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->


          <el-form-item label="商品状态" prop="status">
            <el-select v-model="formInline.status" placeholder="请选择商品状态">
              <el-option label="上架中" :value = 1></el-option>
              <el-option label="已下架" :value = 0 ></el-option>
            </el-select>
          </el-form-item>


          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <!--列表-->
        <el-tabs v-model="editableTabsValue" type="card" style="margin-bottom: 20px;margin-left: 50px"
                 @tab-click="tablesListByExhId">
          <el-tab-pane
            v-for="(item, index) in exhList"
            :key="item.id"
            :label="item.exhibitionName"
            :name="item.id">


            <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                      highlight-current-row v-loading="loading" border
                      element-loading-text="拼命加载中" style="width: 100%;">

              <el-table-column prop="id" label="商品ID" align="center"></el-table-column>
              <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
              <el-table-column prop="exhibitionName" label="所属展会" align="center"></el-table-column>
              <el-table-column prop="parentName" label="所属分类" align="center"></el-table-column>
              <el-table-column prop="sellingPrice" label="价格" align="center"></el-table-column>
              <el-table-column prop="cashPledge" label="押金" align="center"></el-table-column>
              <el-table-column prop="salesVolume" label="销量" align="center"></el-table-column>
              <el-table-column prop="isRecommend" label="首页推荐" align="center">
                <template slot-scope="scope">
                  <el-tag type="danger" v-if="scope.row.isRecommend==0">否</el-tag>
                  <b v-else>是：推荐顺序{{scope.row.recommendSort}}</b>
                </template>
              </el-table-column>

              <el-table-column align="center"  prop="status" label="状态" width="170px" >
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.status"
                    active-text="上架中"
                    inactive-text="已下架"
                    :active-value="1"
                    :inactive-value="0"
                    @change="turn(scope.row)">
                  </el-switch>
                </template>
              </el-table-column>

              <el-table-column  label="操作" align="left" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" type="warning" @click="handleEdit(scope.row)"style="width: 100px;margin: 1px;">编辑</el-button>
                  <el-button size="mini" type="danger" @click="deleteData(scope.row.id)"style="width: 100px;margin: 1px;">删除</el-button>
                </template>
              </el-table-column>

            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


          </el-tab-pane>
        </el-tabs>



        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form label-width="120px" :model="editForm" ref="editForm"  :rules="rules">
            <el-form-item label="标题" prop="title">
              <el-input size="small" v-model="editForm.title"  :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" placeholder="请输入试卷名称"></el-input>
            </el-form-item>

            <el-form-item label="图片" prop="cover">
              <el-upload
                class="avatar-uploader"
                :action="this.host+'/fileUpload/ossBatch'"
                :show-file-list="false"
                :on-success="handleAvatarSuccessImage"
                :before-upload="beforeAvatarUpload">
                <img v-if="editForm.image" :src="editForm.image" class="avatar" width="200">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">建议上传图片 256 * 144 的大小,限时答题 建议上传图片 900 * 383 的大小</div>
              </el-upload>
            </el-form-item>

            <el-form-item label="跳转链接" prop="url">
              <el-input size="small" v-model="editForm.url"  :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" placeholder="请输入试卷名称"></el-input>
            </el-form-item>

            <el-form-item label="所属展会" prop="exhibitionId">
              <el-select v-model="editForm.exhibitionId" placeholder="请选择">
                <el-option
                  v-for="item in exhList"
                  :key="item.id"
                  :label="item.exhibitionName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="活动时间" prop="beginTime">
              <el-date-picker
                v-model="baseForm"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
              <el-input type="number"  v-model="editForm.sort" ></el-input>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>


      </el-main>
    </el-container>
  </div>
</template>

<script>



import {qryCommodityList,qryList,upStatus,delShop} from '../../api/lotteryApi'
import {qryExhibitionList} from '../../api/courseApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";


export default {
  name: "signInLogList",
  data() {
    return {
      title:'添加',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        name:'',
        exhibitionId:'',
        status:'',
        parentId:'',
        page:1,
        pageSize:10
      },
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      baseForm: '',
      editableTabsValue: null,
      editForm:{
        id:'',
        title:'',
        image:'',
        url:'',
        exhibitionId:'',
        sort:'',
        beginTime:'',
        endTime:'',
      },
      // rules表单验证
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ] ,
        url: [
          { required: true, message: '请输入跳转地址', trigger: 'blur' }
        ],
      },
      exhList:[],
      comList:[],
    }
  },
  mounted() {
    this.tableList();
    if(this.$route.query.exId){
      this.editableTabsValue = this.$route.query.exId
      this.$forceUpdate();
    }
  },
  methods:{
    tableList(){
      this.loading = true;
      qryExhibitionList({pageSize:1000}).then(res => {
        this.exhList = res.data.list;
        if (this.editableTabsValue == 0){
          this.editableTabsValue=res.data.list[0].id
        }
        this.formInline.exhibitionId = this.editableTabsValue

        qryCommodityList({pageSize:1000}).then(res => {
          this.comList = res.data.list;
        })

        qryList(this.formInline).then(res => {
          this.listData = res.data.list;
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.pageSize;
          this.pageparm.total = res.data.total;
          this.loading = false
        })
      })

    },

    turn(row) {
      var data={
        id:row.id,
        status:row.status
      }
      upStatus(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
      })
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },

    handleAdd(info) {
      this.$router.push({ path: '/lottery/commodityEdit',query:{exId:this.editableTabsValue}})
    },

    //显示编辑界面
    handleEdit(info) {
      if (info){
        this.$router.push({ path: '/lottery/commodityEdit' ,query:{commodityInfo:info,typeId:info.typeId,exId:this.editableTabsValue}})
      }
      console.log("info",info)
    },
    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.baseForm = [];
      this.editFormVisible = false;
    },
    handleAvatarSuccessImage(res) {
      this.editForm.image = res.data;
    },
    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },


    // 编辑、添加提交方法
    submitForm(editData) {
      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upBanner(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.formInline.exhibitionId = this.editableTabsValue
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          else{
            addBanner(this.editForm)
              .then(res => {
                if (res.code==1) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.formInline.exhibitionId = this.editableTabsValue
                  this.tableList(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },

    deleteData(id) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          delShop({id:id})
            .then(res => {
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                this.formInline.exhibitionId = this.editableTabsValue
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

    resetFrom(){
      this.formInline.name = '';
      this.formInline.status = '';
      this.formInline.exhibitionId = '';
      this.formInline.parentId = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },

    //根据表头显示数据
    tablesListByExhId(){
      this.loading = true;
      this.formInline.exhibitionId = this.editableTabsValue;
      qryList(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })
    },



  },
  //分页组件
  components: {
    ElInputNumber,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lottery/signInLogList.vue